import { Box, Typography } from "@mui/material";
import ResponsiveAppBar from "../assets/components/ResponsiveAppBar.tsx";
import ScheduleTourFlow from "../assets/components/ScheduleTourFlow.tsx";
import ContactFooter from "./ContactFooter.tsx";
import Footer from "./Footer.tsx";

function ScheduleTour() {
    return (
        <>
            <Box sx={{}}>
                <ResponsiveAppBar/>
                <Box className={'tile'} sx={{mb: 20}}>
                    <br/>
                    <Typography
                        sx={{
                            marginTop: 'unset',
                            textAlign: 'center',
                            fontSize: {md: '4rem', xs: '2.0rem'},
                            fontWeight: '900'
                        }}
                    >
                        Schedule a Tour
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mt: 5,
                        px: {xs: 2, md: 5}
                    }}>
                        <ScheduleTourFlow/>
                    </Box>
                </Box>
                <ContactFooter/>
                <Footer/>
            </Box>
        </>
    );
}

export default ScheduleTour;